import React, { useEffect, useState } from "react";
import "./PieceList.css";
import { useSelector } from "react-redux";
import Locale from "../../locales";
import PieceListItem from "./PieceListItem/PieceListItem";
import { PIECES_STATUS, PIECES_TITLE } from "../../constants/pieces";

const PieceList = () => {
  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const pieces = useSelector((state) => state.teacherReducer.pieces);

  const [organizedPieces, setOrganizedPieces] = useState([]); // [{ title: PIECES_STATUS, data: [] }]

  useEffect(() => {
    const completed = [];
    const idle = [];
    const ongoing = [];
    const discontinued = [];
    pieces.forEach((p) => {
      switch (p.pieceStatus) {
        case PIECES_STATUS.COMPLETED:
          completed.push(p);
          break;
        case PIECES_STATUS.DISCONTINUED:
          discontinued.push(p);
          break;
        case PIECES_STATUS.IDLE:
          idle.push(p);
          break;
        case PIECES_STATUS.ONGOING:
          ongoing.push(p);
          break;
        default:
          break;
      }
    });

    setOrganizedPieces([
      { title: PIECES_TITLE.IDLE, data: idle },
      { title: PIECES_TITLE.ONGOING, data: ongoing },
      { title: PIECES_TITLE.COMPLETED, data: completed },
      { title: PIECES_TITLE.DISCONTINUED, data: discontinued },
    ]);
  }, [pieces]);

  return (
    <div className="piece-list-container">
      <div className="piece-list-heading-container">
        <h1 className="piece-list-header-text">{Locale.t("view_pieces")}</h1>
      </div>
      <div className="piece-list-section-container main-section">
        {pieces.length !== 0 &&
          organizedPieces.map(({ title, data }) => (
            <div key={title}>
              {data.length ? (
                <>
                  <p className="piece-list-status">{title}</p>
                  {data.map((piece) => (
                    <PieceListItem piece={piece} key={piece.pieceId} />
                  ))}
                </>
              ) : null}
            </div>
          ))}
        {pieces.length === 0 && (
          <div className="empty-piece-list-item">
            {currentStudent === "" ? (
              <h1>{Locale.t("select_a_student")}</h1>
            ) : (
              <h1>{Locale.t("no_current_pieces")}</h1>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PieceList;
